import type { ReactNode } from 'react';

interface ILoginLayoutProps {
  children: ReactNode;
}

const LoginLayout = ({ children }: ILoginLayoutProps) => {
  return (
    <div className="flex h-full w-full items-center justify-center p-4">
      <div className="bg-secondary_subtle shadow-xs flex w-full max-w-[560px] flex-col gap-2 rounded-3xl p-10">
        {children}
      </div>
    </div>
  );
};

LoginLayout.displayName = 'LoginLayout';

export default LoginLayout;
